export function isValidDate(value) {
  if (!value) return true;

  let format = 'DD.MM.YYYY';

  if (value.length !== format.length) return false;

  let date = moment(value, format);

  return date.isValid();
}

export function isValidDateFormat(date) {
  return date instanceof Date && !isNaN(date.getTime());
}

export function isValidDateCheck(dateString) {
  if (!dateString) return false;
  return moment(dateString, ['DD.MM.YYYY', 'DD.MM.YYYY HH:mm'], true).isValid();
}